
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/forgot/teamid",
      function () {
        return require("private-next-pages/signin/forgot/teamid.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin/forgot/teamid"])
      });
    }
  